"use strict";

require("bootstrap");
require("magnific-popup");
require("slick-carousel");
require("accordion");
require("lightgallery");
require("lg-thumbnail");

(function ($) {
  var laClasse = {
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        // MenuMobile
        $(".menu-toggle").on("click", function () {
          $(".main-menu").toggleClass("open");
          $(this).toggleClass("open");
          $("body").toggleClass("no-scroll");
        });

        // LAUNCH SEARCH
        $(".search-wrapper input#s").on("keypress", function (event) {
          // Enter pressed?
          if (event.which == 10 || event.which == 13) {
            if ($(this).val() != "") {
              window.location = baseUrl + "?s=" + $(this).val();
            }
            // window.location = window.location.origin + '?s=' + $(this).val();
          }
        });
        $('.search-wrapper input[type="submit"]').on("click", function (e) {
          e.preventDefault();
          if ($(".search-wrapper input#s").val() != "") {
            window.location =
              baseUrl + "?s=" + $(".search-wrapper input#s").val();
          }
        });

        // CAMBIO PAGINA
        $(".aep_pagination .page").on("click", function () {
          var page = $(this).attr("data-page");
          var dataString = "";
          var s = getUrlParameter("s");
          if (s != "") {
            dataString = dataString + "?s=" + s + "&pagina=" + page;
          } else {
            dataString = dataString + "?pagina=" + page;
          }
          // Lunch page
          window.location =
            window.location.origin + window.location.pathname + dataString;
        });

        // ACCORDIONs
        $(".accordion-item-title").on("click", function (event) {
          event.preventDefault();
          $(this).parents(".accordion-item").toggleClass("open");
        });
        // $('.accordione-headline').on('click', function (event) {
        //     event.preventDefault();
        //     $(this).parents('.accordione-item').toggleClass('open');
        // });

        // MOBILE LINK LISTS
        $(".link-list h3").on("click", function (event) {
          event.preventDefault();
          if ($(window).width() < 992) {
            $(this).parents(".link-list").toggleClass("open");
          }
        });

        initStandardSlider($);
        initMultipleSlider($);
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $(window).trigger("scroll");
      },
    },
    page_template_page_homepage: {
      init: function () {
        // JavaScript to be fired on HOMEPAGE

        // initNewsletterScroll($);
        // initWebinarScroll($);
        // initPodcastScroll($);
        // initTabAnchor($);
        // initStandardSlider($);
        // initMultipleSlider($);
        // initAppTabs($);

        $(".main-menu li.jumpto a").on("click", function (event) {
          event.preventDefault();
          if ($(window).width() < 992) {
            $(".menu-toggle").trigger("click");
          }
          var target = $(this).attr("href");
          var hash = target.substring(target.indexOf("#"));
          $("html, body").animate(
            {
              scrollTop: $(hash).offset().top - 50,
            },
            400
          );
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    page_template_page_podcast: {
      init: function () {
        // JavaScript to be fired on HOMEPAGE

        $(".showmore").click(function () {
          event.preventDefault();
          $(".podcast.list").addClass("all");
          $(this).remove();
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    search: {
      init: function () {
        // JavaScript to be fired on HOMEPAGE

        window.scrollTo(0, $(".podcasts").offset().top);
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    tax_event_category: {
      init: function () {
        // JavaScript to be fired on HOMEPAGE

        window.scrollTo(0, $(".podcasts").offset().top);
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    page_template_page_academy_itas: {
      init: function () {
        // JavaScript to be fired on HOMEPAGE
        var currentFilter = "";
        $(".itas-podcast .filter").on("click", function () {
          var target = $(this).attr("data-cat");
          if (target == currentFilter) {
            $(".itas-podcast .filter").removeClass("active");
            $(".itas-podcast .js-multiple-slider").slick("slickUnfilter");
          } else {
            currentFilter = target;
            $(".itas-podcast .filter").removeClass("active");
            $(this).addClass("active");
            $(".itas-podcast .js-multiple-slider").slick("slickUnfilter");
            $(".itas-podcast .js-multiple-slider").slick(
              "slickFilter",
              function () {
                return $("." + target, this).length === 1;
              }
            );
          }
        });
        $(window).on("resize", function () {
          $(".itas-block").each(function (index) {
            var minHeight = parseInt(
              $(this).find(".itas-block__image").outerHeight()
            );
            $(this).find(".itas-block__content").css("min-height", minHeight);
          });
        });
        $(window).trigger("resize");
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
  };

  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = laClasse;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery);

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

// function initAppTabs($) {
//     var $inkBar = $('.app-tabs__ink-bar');

//     // var $inkBarMobile = $('.app-tabs__ink-bar-mobile');

//     function handleNewActiveTab(e) {
//         var $newActiveTab = $(e.target).parent();
//         $inkBar.css({
//             left: parseInt($newActiveTab.position().left),
//             width: parseInt($newActiveTab.width())
//         });
//         // $inkBarMobile.css({
//         //     top: parseInt($newActiveTab.position().top),
//         //     height: parseInt($newActiveTab.height())
//         // });
//     }

//     function refreshActiveTab() {
//         handleNewActiveTab({target: $('.app-tabs__nav a.active').get(0)});
//     }

//     $('.app-tabs__nav a[data-toggle="tab"]').on('shown.bs.tab', handleNewActiveTab);
//     refreshActiveTab()

//     $(window).resize(function () {
//         refreshActiveTab()
//     });
// }

function initStandardSlider($) {
  const $slider = $(".js-standard-slider");
  if ($slider.length) {
    $slider.slick({
      dots: false,
      infinite: true,
      autoplaySpeed: 5000,
      speed: 400,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: true,
      focusOnSelect: true,
      pauseOnHover: false,
      swipeToSlide: true,
      adaptiveHeight: false,
      arrows: true,
      prevArrow: $slider.parents(".js-standard-slider-wrapper").find(".prev"),
      nextArrow: $slider.parents(".js-standard-slider-wrapper").find(".next"),
      //cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    });
  }
}

function initMultipleSlider($) {
  $(".js-multiple-slider").each(function () {
    var slides = parseInt($(this).attr("data-slides"));
    var mobileSlides = $(this).attr("data-mobile-slides")
      ? parseInt($(this).attr("data-mobile-slides"))
      : 1;
    var autoplay = $(this).attr("data-autoplay") == "false" ? false : true;
    if ($(this).length) {
      $(this).slick({
        dots: false,
        infinite: false,
        autoplaySpeed: 5000,
        speed: 400,
        autoplay: false,
        slidesToShow: slides,
        slidesToScroll: 1,
        accessibility: true,
        focusOnSelect: false,
        pauseOnHover: false,
        swipeToSlide: true,
        adaptiveHeight: false,
        arrows: true,
        prevArrow: $(this).parents(".js-multiple-slider-wrapper").find(".prev"),
        nextArrow: $(this).parents(".js-multiple-slider-wrapper").find(".next"),
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: mobileSlides + 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: mobileSlides,
              slidesToScroll: 1,
            },
          },
        ],
        //cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
      });
      // console.log('debug: ' + $(this).hasClass('slick-initialized'));

      if ($(this).hasClass("slick-initialized") != 1) {
        $(this)
          .parents(".js-multiple-slider-wrapper")
          .find(".multiple-slider-arrows")
          .hide();
      }
    }
  });

  // ------ Laboratori edit 10-2021 ----
  // Carousel solo mobile
  $(".labs-slider").each(function () {
    var slides = parseInt($(this).attr("data-slides"));
    var mobileSlides = $(this).attr("data-mobile-slides")
      ? parseInt($(this).attr("data-mobile-slides"))
      : 1;
    var autoplay = $(this).attr("data-autoplay") == "false" ? false : true;
    if ($(this).length) {
      $(this).slick({
        dots: false,
        infinite: false,
        autoplaySpeed: 5000,
        speed: 400,
        autoplay: false,
        // slidesToShow: slides,
        slidesToScroll: 1,
        variableWidth: true,
        accessibility: true,
        focusOnSelect: true,
        pauseOnHover: false,
        swipeToSlide: true,
        adaptiveHeight: false,
        arrows: true,
        prevArrow: $(this).parents(".labs-slider-wrapper").find(".prev"),
        nextArrow: $(this).parents(".labs-slider-wrapper").find(".next"),
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: mobileSlides + 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 993,
            settings: "unslick",
          },
        ],
      });

      var currSlider = $(this);
      $(window).on("resize", function () {
        if (currSlider.hasClass("slick-initialized") != 1) {
          //&& $(window).width() <= 992
          currSlider.slick({
            dots: false,
            infinite: false,
            autoplaySpeed: 5000,
            speed: 400,
            autoplay: false,
            // slidesToShow: mobileSlides,
            slidesToScroll: 1,
            variableWidth: true,
            accessibility: true,
            focusOnSelect: true,
            pauseOnHover: false,
            swipeToSlide: true,
            adaptiveHeight: false,
            arrows: true,
            prevArrow: currSlider.parents(".labs-slider-wrapper").find(".prev"),
            nextArrow: currSlider.parents(".labs-slider-wrapper").find(".next"),
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: mobileSlides + 1,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 993,
                settings: "unslick",
              },
            ],
            //cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
          });
        }
      });
    }
  });

  // -----------------------------------

  // ------- ITAS NEWS SLIDER ----------
  $(".itas-news-slider").each(function () {
    var slides = parseInt($(this).attr("data-slides"));
    var mobileSlides = $(this).attr("data-mobile-slides")
      ? parseInt($(this).attr("data-mobile-slides"))
      : 1;
    var autoplay = $(this).attr("data-autoplay") == "false" ? false : true;
    if ($(this).length) {
      $(this).slick({
        dots: false,
        infinite: false,
        autoplaySpeed: 5000,
        speed: 400,
        autoplay: false,
        // slidesToShow: slides,
        slidesToScroll: 1,
        variableWidth: true,
        accessibility: true,
        focusOnSelect: true,
        pauseOnHover: false,
        swipeToSlide: true,
        adaptiveHeight: false,
        arrows: true,
        prevArrow: $(this).parents(".itas-news-slider-wrapper").find(".prev"),
        nextArrow: $(this).parents(".itas-news-slider-wrapper").find(".next"),
        // mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: mobileSlides + 1,
              slidesToScroll: 1,
            },
          },
          //   {
          //     breakpoint: 993,
          //     settings: "unslick",
          //   },
        ],
        //cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
      });
      // console.log('debug: ' + $(this).hasClass('slick-initialized'));

      // if ($(this).hasClass('slick-initialized') != 1) {
      //     $(this).parents('.labs-slider-wrapper').find('.multiple-slider-arrows').hide();
      // }
      var currSlider = $(this);
      $(window).on("resize", function () {
        if (currSlider.hasClass("slick-initialized") != 1) {
          //&& $(window).width() <= 992
          currSlider.slick({
            dots: false,
            infinite: false,
            autoplaySpeed: 5000,
            speed: 400,
            autoplay: false,
            // slidesToShow: mobileSlides,
            slidesToScroll: 1,
            variableWidth: true,
            accessibility: true,
            focusOnSelect: true,
            pauseOnHover: false,
            swipeToSlide: true,
            adaptiveHeight: false,
            arrows: true,
            prevArrow: currSlider
              .parents(".itas-news-slider-wrapper")
              .find(".prev"),
            nextArrow: currSlider
              .parents(".itas-news-slider-wrapper")
              .find(".next"),
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: mobileSlides + 1,
                  slidesToScroll: 1,
                },
              },
              //   {
              //     breakpoint: 993,
              //     settings: "unslick",
              //   },
            ],
            //cssEase: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
          });
        }
      });
    }
  });
  // -----------------------------------
}

// function initNewsletterScroll($) {
//     $('.top .btn').click(function (e) {
//         e.preventDefault();
//         var target = $(this).attr('href');
//         $('html, body').animate({
//             scrollTop: $(target).offset().top + 2
//         }, 400);
//     });
// }

// function initWebinarScroll($) {
//     function handleTarget(target) {
//         $('.app-tabs__nav a[href="#tab-webinar"]').tab('show');
//         var $target = $(target);
//         if($target.length > 0) {
//             setTimeout(function () {
//                 $('html, body').animate({
//                     scrollTop: $target.offset().top - 50
//                 }, 400);
//             }, 400);
//         }
//     }

//     var url = document.location.toString();
//     if (url.match('#webinar-')) {
//         window.onload = function () {
//             handleTarget('#' + url.split('#')[1]);
//         }
//     }
//     $('a.webinarScroll[href^="#webinar-"]').click(function (e) {
//         e.preventDefault();
//         handleTarget($(this).attr('href'));
//     });
// }

// function initPodcastScroll($) {
//     function handleTarget(target) {
//         $('.app-tabs__nav a[href="#tab-podcast"]').tab('show');
//         var query = target.replace('#podcast-', 'id:');
//         setTimeout(function () {
//             var $search = document
//                 .getElementById('podcast-list')
//                 .shadowRoot.getElementById('comp-search');
//             $search.value = query;
//             $search.dispatchEvent(new Event('input', {'bubbles': true}))
//             $('html, body').animate({
//                 scrollTop: document
//                     .getElementById('podcast-list')
//                     .shadowRoot.getElementById('comp-search').offsetTop - 10
//             }, 400);
//         }, 400);
//     }

//     var url = document.location.toString();
//     if (url.match('#podcast-')) {
//         window.onload = function () {
//             handleTarget('#' + url.split('#')[1]);
//         }
//     }
//     $('a.webinarScroll[href^="#podcast-"]').click(function (e) {
//         e.preventDefault();
//         handleTarget($(this).attr('href'))
//     });
// }

// function initTabAnchor($) {
//     var url = document.location.toString();
//     if (url.match('#tab-')) {
//         var target = '#' + url.split('#')[1];
//         var $target = $(target);
//         if($target.length > 0) {
//             $('.app-tabs__nav a[href="' + target + '"]').tab('show');
//             window.onload = function () {
//                 $('html, body').animate({
//                     scrollTop: $target.offset().top - 150
//                 }, 400);
//             }
//         }
//     }

//     // Change hash for page-reload
// //    $('.app-tabs__nav a').click(function (e) {
// //       window.location.hash = e.target.hash;
// //    });
// }
